<template>
    <div style="height: 100%">
        <div class="container">
            <div class="login">
                <img class="logo" src="../assets/logo.png" alt="Logo" width="100%">
                <el-form ref="form" :model="form" :rules="rules" @submit.native.prevent="login">
                    <el-form-item prop="username">
                        <el-input :placeholder="$t('用户名')" v-model="form.username" autofocus="true" clearable></el-input>
                    </el-form-item>
                    <el-form-item prop="password">
                        <el-input :placeholder="$t('密码')" v-model="form.password" show-password></el-input>
                    </el-form-item>
                    <!-- 验证码行 -->
                    <el-form-item prop="smsCode">
                      <div class="code-container">
                        <el-input
                            :placeholder="$t('验证码')"
                            v-model="form.smsCode"
                            class="code-input"
                        ></el-input>
                        <el-button
                            type="primary"
                            class="send-btn"
                            :disabled="!!timer || !form.username"
                            @click="sendCode"
                        >
                          {{ timer ? `${countdown}s` : $t('获取验证码') }}
                        </el-button>
                      </div>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" class="button" native-type="submit">{{$t('登录')}}</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>


      <!-- 修改密码弹窗 -->
      <el-dialog
          :title="$t('首次登录，请修改密码')"
          :visible.sync="showUpdateDialog"
          :close-on-click-modal="false"
          :close-on-press-escape="false"
          width="400px"
          append-to-body
      >
        <el-form :model="updateForm" :rules="updateRules" ref="updateForm" label-width="120px" @submit.native.prevent>
          <el-form-item :label="$t('用户名')" prop="username">
            <el-input v-model="updateForm.username" disabled></el-input>
          </el-form-item>
          <el-form-item :label="$t('当前密码')" prop="oldPass">
            <el-input v-model="updateForm.oldPass" type="password" show-password></el-input>
          </el-form-item>
          <el-form-item :label="$t('新密码')" prop="newPass">
            <el-input v-model="updateForm.newPass" type="password" show-password></el-input>
          </el-form-item>
          <el-form-item :label="$t('确认新密码')" prop="confirmPass">
            <el-input v-model="updateForm.confirmPass" type="password" show-password></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer">
          <el-button type="primary" @click="submitUpdate" :loading="updating">{{$t('提交')}}</el-button>
          <el-button @click="showUpdateDialog = false">{{$t('取消')}}</el-button>
        </div>
      </el-dialog>




        <div style="position: absolute;top: 10px;right: 10px">
            <el-dropdown @command="changeLocale">
                <div class="el-dropdown-link">
                    {{$t('语言')}}<i class="el-icon-arrow-down el-icon--right"></i>
                </div>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="zh">中文</el-dropdown-item>
                    <el-dropdown-item command="en">English</el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
        </div>
        <div style="position: absolute;bottom: 0;line-height: 30px;width: 100%;text-align: center;font-size: 13px;">
            <a href="http://www.beian.miit.gov.cn" target="_blank" style="color: #000">京ICP备11038982号-11</a>
        </div>
    </div>
</template>

<i18n locale="en" lang="yaml">
    "用户名": "User Name"
    "密码": "Password"
    "登录": "Login"
    "语言": "Language"
    "请输入用户名": "Please input username"
    "请输入密码": "Please input password"
    "验证码": "Verification Code"
    "获取验证码": "Send Code"
    "请输入验证码": "Please input verification code"
    "验证码已发送": "Code sent"
    "发送失败": "Send failed"
    "首次登录，请修改密码": "First login, please change password"
    "当前密码": "Current Password"
    "新密码": "New Password"
    "确认新密码": "Confirm Password"
    "提交": "Submit"
    "取消": "Cancel"
    "修改成功": "Password changed successfully"
</i18n>

<script>
    import qs from 'qs';

    export default {
        data() {
            return {
                form: {
                    username: '',
                    password: '',
                    smsCode: ''
                },
                rules: {
                    username: [
                        {required: true, message: this.$t('请输入用户名')}
                    ],
                    password: [
                        {required: true, message: this.$t('请输入密码')}
                    ],
                    smsCode: [
                      { required: true, message: this.$t('请输入验证码') }
                    ]
                },
              timer: null,      // 用于存储 setInterval 的返回值
              countdown: 60,     // 倒计时初始值

              // 新增：弹窗相关
              showUpdateDialog: false,
              updating: false,
              updateForm: {
                username: '',
                oldPass: '',
                newPass: '',
                confirmPass: ''
              },

              updateRules: {
                oldPass: [
                  { required: true, message: this.$t('请输入当前密码'), trigger: 'blur' },
                  { min: 6, message: '密码长度不能小于6位', trigger: 'blur' }
                ],
                newPass: [
                  { required: true, message: this.$t('请输入新密码'), trigger: 'blur' },
                  { min: 6, message: '密码长度不能小于6位', trigger: 'blur' }
                ],
                confirmPass: [
                  { required: true, message: this.$t('请确认新密码'), trigger: 'blur' },
                  { validator: (rule, value, callback) => {
                      if (value !== this.updateForm.newPass) {
                        callback(new Error('两次输入密码不一致'));
                      } else {
                        callback();
                      }
                    }, trigger: 'blur' }
                ]
              }
            }
        },
        methods: {
            login() {
                this.$utils.submit(this.$refs.form, "/login", qs.stringify(this.form), (data) => {

                  debugger
                  if (data.code === -9) {
                    // 后端返回 { code: -9, msg: "..." }，需要改密码
                    // 填充弹窗表单
                    this.updateForm.username = this.form.username;
                    this.updateForm.oldPass = this.form.password; // 自动填入当前密码
                    this.showUpdateDialog = true;
                    return;
                  }


                    sessionStorage.setItem("auth-token", data);

                    this.$root.loadUserInfo().then(() => {
                        this.$root.loadMenus().then(() => {
                            this.redirect();
                        });
                    });
                });
            },
            submitUpdate() {
              this.$refs.updateForm.validate(valid => {
                if (!valid) return;

                this.updating = true;
                const params = {
                  userName: this.updateForm.username,
                  oldPass: this.updateForm.oldPass,
                  newPass: this.updateForm.newPass
                };

                this.$axios.post('/index/updatepass', qs.stringify(params), {
                  headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
                }).then(res => {
                  if (res.code === 0) {
                    this.$message.success(this.$t('修改成功'));
                    this.showUpdateDialog = false;
                    // ✅ 不自动登录，不清空表单，让用户自己重新登录
                  } else {
                    this.$message.error(res.msg || '修改失败');
                  }
                }).finally(() => {
                  this.updating = false;
                });
              });
            },
            redirect() {
                if (this.$root.user.type === 'USER') {
                    location.href = this.$root.services[0]['path'];
                } else {
                    this.$router.push("/index");
                }
            },
            changeLocale(local) {
                this.$i18n.locale = local;
                localStorage.setItem("local", local);
                this.$router.go(0);
            },
            sendCode() {
              // 校验用户名是否填写
              if (!this.form.username) {
                this.$message.warning(this.$t('请输入用户名'));
                return;
              }

              // 使用 this.$axios.post，模仿你给的 resetpass 写法
              this.$axios.get('/index/loginSms?userName=' + this.form.username).then(response => {
                // 假设后端返回格式：{ code: 0, msg: "ok" }
                if (response.code === 0) {
                  this.$message.success(this.$t('验证码已发送'));
                  this.startCountdown(); // 启动倒计时
                } else {
                  this.$message.error(response.message || this.$t('发送失败'));
                }
              }).catch(err => {
                // 请求失败（网络错误、500 等）
                console.error('发送验证码失败:', err);
                this.$message.error(this.$t('发送失败'));
              });
            },
            startCountdown() {
              this.timer = setInterval(() => {
                this.countdown--;
                if (this.countdown <= 0) {
                  this.clearTimer();
                }
              }, 1000);
            },
            clearTimer() {
              if (this.timer) {
                clearInterval(this.timer);
                this.timer = null;
                this.countdown = 60;
              }
            }
        },
        beforeDestroy() {
          // 组件销毁前清除定时器
          this.clearTimer();
        }
    }
</script>
<style scoped>
    .container {
        display: flex;
        height: 100%;
        flex-direction: column;
        justify-content: center;
    }

    .login {
        width: 300px;
        margin: 0 auto;
        text-align: center;
    }

    .button {
        width: 100%;
    }

    .code-container {
      display: flex;
      gap: 10px; /* 按钮和输入框之间的间距 */
      align-items: center; /* 垂直居中对齐 */
    }

    .code-container .code-input {
      flex: 1; /* 输入框占据剩余空间 */
    }

    .code-container .send-btn {
      white-space: nowrap; /* 防止按钮文字换行 */
      width: auto; /* 自动宽度 */
    }
</style>